import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-list-segmented",
  templateUrl: "./med-icon-list-segmented.component.html",
})
export class MedIconListSegmentedComponent extends SvgMixinComponent {}
